import type { IMelhorEnvioConfig } from "interfaces/loja";

export const DEFAULT_MELHOR_ENVIO_CONFIG: IMelhorEnvioConfig = {
  email: "",
  sandbox: true,
  tokenStaticSandbox: "",
  clientId: null,
  clientSecret: null,
  oauthConectado: false,
  userAgent: "",
  ativo: false,
  servicos: "",
};

export function normalizeMelhorEnvioConfig(raw: Record<string, unknown>): IMelhorEnvioConfig {
  const servicoStr =
    typeof raw?.servico === "string"
      ? raw.servico
      : Array.isArray(raw?.servicos)
        ? (raw.servicos as unknown[]).map(String).join(",")
        : Array.isArray(raw?.service_ids)
          ? (raw.service_ids as unknown[]).map(String).join(",")
          : typeof raw?.servicos === "string"
            ? raw.servicos
            : "";

  return {
    id: raw?.id as string | undefined,
    email: (raw?.email as string) ?? "",
    cepOrigem: (raw?.cepOrigem as string | null) ?? null,
    sandbox: Boolean(raw?.sandbox),
    tokenStaticSandbox: (raw?.tokenStaticSandbox as string | null) ?? null,
    clientId: (raw?.clientId as string | null) ?? null,
    clientSecret: (raw?.clientSecret as string | null) ?? null,
    oauthConectado: Boolean(raw?.oauthConectado),
    userAgent: (raw?.userAgent as string) ?? "",
    ativo: Boolean(raw?.ativo),
    servicos: servicoStr,
    createdAt: raw?.createdAt as string | undefined,
    updatedAt: raw?.updatedAt as string | undefined,
  };
}

export function countSelectedServicos(servicos: string | undefined | null): number {
  if (!servicos?.trim()) return 0;
  return servicos
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean).length;
}

export function computeMelhorEnvioStats(config: IMelhorEnvioConfig | null) {
  if (!config) {
    return {
      ativo: false,
      oauth: false,
      sandbox: true,
      servicos: 0,
      salvo: false,
    };
  }
  return {
    ativo: Boolean(config.ativo),
    oauth: Boolean(config.oauthConectado),
    sandbox: Boolean(config.sandbox),
    servicos: countSelectedServicos(config.servicos),
    salvo: Boolean(config.id),
  };
}

export function validateMelhorEnvioConfig(
  config: IMelhorEnvioConfig,
): { ok: true } | { ok: false; msg: string } {
  if (!config.email?.trim()) {
    return { ok: false, msg: "E-mail é obrigatório." };
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(config.email)) {
    return { ok: false, msg: "E-mail inválido." };
  }

  if (config.sandbox && !config.tokenStaticSandbox?.trim()) {
    return {
      ok: false,
      msg: "Token Sandbox é obrigatório quando Sandbox está ativado.",
    };
  }

  if (!config.sandbox) {
    if (!config.clientId?.trim()) {
      return {
        ok: false,
        msg: "Client ID é obrigatório quando Sandbox está desativado.",
      };
    }
    if (!config.clientSecret?.trim()) {
      return {
        ok: false,
        msg: "Client Secret é obrigatório quando Sandbox está desativado.",
      };
    }
  }

  if (!config.userAgent?.trim()) {
    return { ok: false, msg: "User Agent é obrigatório." };
  }

  return { ok: true };
}

export function buildMelhorEnvioPayload(config: IMelhorEnvioConfig): IMelhorEnvioConfig {
  return {
    id: config.id || "",
    email: config.email.trim(),
    cepOrigem: config.cepOrigem,
    sandbox: Boolean(config.sandbox),
    tokenStaticSandbox: config.sandbox ? config.tokenStaticSandbox?.trim() || null : null,
    clientId: !config.sandbox ? config.clientId?.trim() || null : null,
    clientSecret: !config.sandbox ? config.clientSecret?.trim() || null : null,
    userAgent: config.userAgent.trim(),
    ativo: Boolean(config.ativo),
    servicos: config.servicos.trim(),
  };
}
